import * as manageNoticeActions from '../actions/ManageNotices';

const initialState = {
  manageNotices: []
};

const manageNotices = (state = initialState, action) => {
  switch (action.type) {
    case manageNoticeActions.GET_MANAGE_NOTICE_SUCCESS:
      return Object.assign({}, state, action.payload);
    case manageNoticeActions.GET_MANAGE_NOTICE_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default manageNotices;
